export enum CollapsePanelVariants {
  FadePreview = 'fade-preview',
  Default = 'default',
}

export type CollapsePanelProps = {
  /** Content to display within the panel */
  children: React.ReactNode;
  /** Class to append to CollapsePanel component */
  addClass?: string;
  /** Whether or not the panel is expanded */
  isOpen: boolean;
  /** Preview content is displayed before the panel is expanded. Preview Content should only be used with the FadePreview CollapsePanelVariant */
  previewContent?: React.ReactNode;
  /** Element which expands or collapses the panel on click */
  trigger: React.ReactNode;
  /** Preset styling and behavior. Options are CollapsePanelVariants.FadePreview and CollapsePanelVariants.Default */
  /** Defaults to CollapsePanelVariants.Default */
  variant?: CollapsePanelVariants;
};
